import { newsApi } from 'app/src/services/welfareportal'
import { formatDate } from 'app/src/shared/helpers'
import { useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { CommonLandingCarousel } from './CommonLandingCarousel'

const NewsTemplate = ({ news, hasOnlyTwoItems = false }: { news: newsApi.News; hasOnlyTwoItems?: boolean }) => {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()

  return (
    <div className={`rounded-lg border bg-white p-4 shadow-md lg:mr-12 ${hasOnlyTwoItems ? '' : 'max-w-lg'}`}>
      <p className='mb-4 font-bold text-black underline decoration-[var(--primary-color)] decoration-4 underline-offset-8'>
        {formatDate(news.date)}
      </p>
      <p className='mb-4 mt-3 line-clamp-2 h-[50px] font-bold text-black'>{news.title}</p>
      <p className='mb-6 line-clamp-4 h-[96px] text-gray-700' dangerouslySetInnerHTML={{ __html: news.content }} />
      <div className='flex justify-start'>
        <Button
          label={t('Landing.NewsFeed.ReadMore')}
          text
          icon='pi pi-arrow-right'
          iconPos='right'
          className=''
          onClick={() => navigate.goToNewsDetail(news.id)}
        ></Button>
      </div>
    </div>
  )
}

export function NewsCarouselSection() {
  const { t } = useTranslation('landing')
  const navigate = useWelfarePortalNavigate()
  const context = useWebAppContext()
  const newsResult = newsApi.useNewsRequestList({
    queryParams: { pagingLimit: 10, pagingOffset: 0 },
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  return (
    !newsResult.isError && (
      <div>
        <div>
          <h2 className='welfareportal-titlecenter'>{t('Landing.NewsFeed.Title')}</h2>
        </div>
        <div className='mt-5'>
          {newsResult.isLoading ? (
            <Skeleton height={257} baseColor='#e5e7eb' highlightColor='#f3f4f6' data-testid='loading-element' />
          ) : (
            <CommonLandingCarousel
              value={newsResult?.data?.items}
              itemTemplate={(news, hasOnlyTwoItems) => <NewsTemplate news={news} hasOnlyTwoItems={hasOnlyTwoItems} />}
              carouselAriaLabel='Carousel delle notizie'
              containerAriaLabel='Elementi del carousel delle notizie'
              indicatorsAriaLabel='Indicatori carousel delle notizie'
            />
          )}
        </div>
        <div className='mb-3 mr-3 mt-3 flex justify-end'>
          <Button
            label={t('Landing.NewsFeed.OpenNewsList')}
            pt={{ root: { className: 'rounded-3xl bg-[white] text-[var(--primary-color)]' } }}
            icon='pi pi-arrow-right'
            iconPos='right'
            onClick={() => navigate.goToNews()}
          />
        </div>
      </div>
    )
  )
}
